/* ELEAT commerce tracking. Preview stays local; production respects analytics consent. */
(function () {
  'use strict';
  if (window.eleatTracking) return;
  var config = window.eleatTrackingConfig || {};
  var VERSION = config.version || '2026-10-07-v1';
  var PREFIX = 'eleat_v2_';
  var roots = new WeakMap();
  var seen = new WeakMap();
  var observed = new WeakSet();
  var seenUpgradeBundles = new Set();
  var events = [];
  var pending = [];
  var flushTimer = 0;
  var viewObserver = null;
  var discoverTimer = 0;
  var consentReady = false;
  var preview = String(config.themeRole).toLowerCase() !== 'main' || Boolean(config.designMode) || Boolean(window.Shopify && window.Shopify.designMode);
  try { preview = preview || new URLSearchParams(location.search).has('preview_theme_id') || new URLSearchParams(location.search).get('eleat_tracking_debug') === '1'; } catch (_) {}

  function id() {
    return window.crypto && typeof window.crypto.randomUUID === 'function' ? window.crypto.randomUUID() : Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
  }
  function safeTrack(name, data) { try { return track(name, data); } catch (_) { return false; } }
  function analyticsAllowed() {
    try { return consentReady && window.Shopify.customerPrivacy.analyticsProcessingAllowed() === true; } catch (_) { return false; }
  }
  function sdkState() {
    try {
      if (!window.igData || !window.igData.user || typeof window.igData.user.getExperiments !== 'function') return 'waiting';
      var experiments = window.igData.user.getExperiments();
      var list = Array.isArray(experiments) ? experiments : Object.values(experiments || {});
      return list.some(function (experiment) { return experiment && experiment.isPreview === true; }) ? 'preview' : 'ready';
    } catch (_) { return 'waiting'; }
  }
  function source(root) {
    if (root && root.matches && root.matches('.product-bundle')) return root.hasAttribute('data-eleat-bundle-landing') ? 'bundle_landing' : 'builder';
    var path = location.pathname;
    if (/oats/.test(path)) return 'oats';
    if (/granola/.test(path)) return 'granola';
    if (/cereal/.test(path) || /^\/products\/bestseller-variety-pack\/?$/.test(path)) return 'cereal';
    if (/landing-product/.test(path)) return 'oats';
    return root && root.matches && root.matches('.component-product-info-alt') ? 'product' : 'storefront';
  }
  function context(root) {
    return {version: VERSION, source: source(root), page_path: /^\/(products|pages|collections)(\/|$)/.test(location.pathname) ? location.pathname : '/', device: window.innerWidth <= 767 ? 'mobile' : window.innerWidth <= 1024 ? 'tablet' : 'desktop'};
  }
  function visible(node, inViewport) {
    if (!node || !node.getBoundingClientRect || !node.isConnected) return false;
    var rect = node.getBoundingClientRect();
    var style = window.getComputedStyle(node);
    if (!rect.width || !rect.height || style.display === 'none' || style.visibility === 'hidden') return false;
    return !inViewport || rect.bottom > 0 && rect.top < window.innerHeight && rect.right > 0 && rect.left < window.innerWidth;
  }
  function enabled(node) {
    return node && !node.disabled && node.getAttribute('aria-disabled') !== 'true' && !node.closest('[inert]');
  }
  function faqOpen(node) {
    var details=node.closest('details');
    if(details) return details.open===true;
    var wrapper=node.closest('.product-template__accordion, .product-faqs__faq, .faqs-lists__faq, .build-a-bundle__accordion');
    var content=wrapper && wrapper.querySelector('.product-template__accordion-container, .product-faqs__faq-answer, .faqs-lists__faq-answer, .build-a-bundle__accordion-answer');
    if(content) return !content.hidden && !content.classList.contains('hidden') && visible(content,false);
    var expanded=node.getAttribute('aria-expanded');
    if(expanded!==null) return expanded==='true';
    var controlled=node.getAttribute('aria-controls');
    content=controlled && document.getElementById(controlled);
    return Boolean(content && !content.hidden && !content.classList.contains('hidden') && visible(content,false));
  }
  function selectionRoot(node) { return node && node.closest && node.closest('.product-bundle, .component-product-info-alt'); }
  function purchaseType(value) { return value === 'onetime' ? 'oneoff' : value || ''; }
  function pdpCadence(active, state, type) {
    if (type !== 'subscription') return 0;
    var explicit = Number(active && active.dataset.frequency);
    if (Number.isFinite(explicit) && explicit > 0) return explicit;
    var note = active && active.querySelector('.plan-option__purchase-note');
    var visibleMatch = note && /\bevery\s+(\d+)\s+weeks?\b/i.exec(note.textContent || '');
    if (visibleMatch) return Number(visibleMatch[1]);
    var stateMatch = /^\s*(\d+)\s+weeks?\s*$/i.exec(state.sellingPlanMatch || '');
    return stateMatch ? Number(stateMatch[1]) : 0;
  }
  function readState(root) {
    if (!root) return {size: 0, selected: 0, signature: '', purchase_type: ''};
    if (root.matches('.component-product-info-alt')) {
      var active = root.querySelector('.product-template__plan-option.active');
      var state = window.flavourBundleState || {};
      var selections = (state.selections || []).map(function (item) { return [String(item.variantId || item.flavourId), Number(item.quantity) || 0]; }).filter(function (item) { return item[1] > 0; }).sort(function (a,b) { return a[0].localeCompare(b[0]); });
      var type = purchaseType(active && active.dataset.purchaseType || state.planPurchaseType);
      return {size: Number(active && active.dataset.quantity) || Number(state.planLimit) || 0, selected: selections.reduce(function (sum,item) { return sum + item[1]; },0), signature: JSON.stringify(selections), purchase_type: type, cadence_weeks: pdpCadence(active, state, type)};
    }
    var sizeButton = root.querySelector('.build-a-bundle__size-button.active[data-size]');
    var contents = root.querySelector('.product-bundle__contents');
    var quantities = {};
    var products = {};
    root.querySelectorAll('.bundle-card__quantity-input').forEach(function (input) {
      var key = String(input.dataset.variantId || input.dataset.productTitle || input.closest('[data-product-id]') && input.closest('[data-product-id]').dataset.productId || '');
      if (key) quantities[key] = Math.max(quantities[key] || 0, Number(input.value) || 0);
      var card=input.closest && input.closest('[data-product-id]');
      var product=String(input.dataset.productId || card && card.dataset.productId || '');
      if(product) products[product]=Math.max(products[product]||0,Number(input.value)||0);
    });
    var items = Object.keys(quantities).filter(function(key) { return quantities[key] > 0; }).sort().map(function (key) { return [key, quantities[key]]; });
    var plan = root.querySelector('.build-a-bundle__type-subscription.active');
    var nativeType=purchaseType(contents && contents.dataset.purchaseType);
    return {size: Number(sizeButton && sizeButton.dataset.size) || 0, selected: items.reduce(function(sum,item) { return sum + item[1]; },0), signature: JSON.stringify(items), product_signature:JSON.stringify(Object.keys(products).filter(function(key){return products[key]>0;}).sort().map(function(key){return [key,products[key]];})), purchase_type: nativeType, cadence_weeks: nativeType==='subscription' ? parseInt(plan && plan.dataset.plan,10) || 0 : 0};
  }
  function rootRecord(root) {
    var record = roots.get(root);
    if (!record) { record = {prefill: null, complete: false}; roots.set(root, record); }
    if(!record.restoreChecked) {
      record.restoreChecked=true;
      if(!record.prefill && (preview || analyticsAllowed())) {
        try {
          var saved=JSON.parse(window.sessionStorage.getItem('eleat:prefill:' + location.pathname) || 'null');
          var current=readState(root);
          if(saved && saved.version===VERSION && Date.now()-saved.savedAt<43200000 && saved.source===source(root) && saved.currentSignature===current.signature && saved.currentSize===current.size) record.prefill=saved.prefill;
        } catch(_) {}
      }
    }
    return record;
  }
  function persistPrefill(root) {
    if(!preview && !analyticsAllowed()) return;
    var record=roots.get(root),state=readState(root);
    if(!record || !record.prefill) return;
    try {window.sessionStorage.setItem('eleat:prefill:' + location.pathname,JSON.stringify({version:VERSION,source:source(root),prefill:record.prefill,currentSignature:state.signature,currentSize:state.size,savedAt:Date.now()}));} catch(_) {}
  }
  function transport(entry) {
    if (preview) { entry.status = 'draft'; return; }
    if (!analyticsAllowed()) { entry.status = 'consent_blocked'; return; }
    var state = sdkState();
    if (state === 'preview') { entry.status = 'experiment_preview'; return; }
    if (state !== 'ready') {
      if (Date.now() - entry.timestamp > 30000) { entry.status = 'sdk_unavailable'; return; }
      entry.status = 'queued';
      if (pending.length < 200) pending.push(entry);
      if (!flushTimer) flushTimer = window.setTimeout(flush, 250);
      return;
    }
    try {
      window.igEvents = window.igEvents || [];
      window.igEvents.push({event: entry.identifier, properties: entry.properties});
      entry.status = 'sent';
    } catch (_) { entry.status = 'sender_failed'; }
  }
  function flush() {
    flushTimer = 0;
    var queue = pending;
    pending = [];
    queue.forEach(transport);
  }
  function syncDebug() {
    if (!preview) return;
    var node=document.getElementById('eleat-tracking-debug');
    if(!node) {node=document.createElement('script');node.type='application/json';node.id='eleat-tracking-debug';document.head.appendChild(node);}
    node.textContent=JSON.stringify(events.slice(-100));
  }
  function track(name, data) {
    var entry = {name: name, identifier: PREFIX + name, properties: Object.assign(context(null), data || {}), timestamp: Date.now(), status: ''};
    if (preview || analyticsAllowed()) { events.push(entry); if (events.length > 200) events.shift(); }
    transport(entry);
    syncDebug();
    if (name === 'prefill_success' || name === 'prefill_viewed') {
      var size = Number(entry.properties.pack_count);
      if ([4,6,8,10].includes(size)) safeTrack(name + '_' + size, entry.properties);
      if (['builder','bundle_landing','oats','cereal','granola'].includes(entry.properties.source)) safeTrack(name + '_' + entry.properties.source, entry.properties);
    }
    return entry.status === 'sent' || entry.status === 'draft' || entry.status === 'queued';
  }
  function once(node, key, name, data) {
    if (!preview && !analyticsAllowed()) return;
    var keys = seen.get(node) || new Set();
    if (keys.has(key)) return;
    keys.add(key); seen.set(node, keys); safeTrack(name, data);
  }
  function prefillViewed(node) {
    if (!visible(node,true) || !enabled(node)) return;
    var root = selectionRoot(node), state = readState(root);
    if (!root || !state.size) return;
    once(root, 'prefill-view-' + state.size, 'prefill_viewed', Object.assign(context(root), {pack_count:state.size, purchase_type:state.purchase_type}));
  }
  function finishPrefill(root, attempt) {
    var state = readState(root);
    var payload = Object.assign(context(root), {prefill_id:attempt.id, pack_count:state.size, selected_count:state.selected, previous_count:attempt.before.selected, purchase_type:state.purchase_type});
    var configuredMix=attempt.expectedSignature && attempt.expectedSignature===state.product_signature;
    if (state.size > 0 && state.selected === state.size && (configuredMix || !attempt.expectedSignature && (state.signature !== attempt.before.signature || attempt.before.selected !== attempt.before.size))) {
      if(preview || analyticsAllowed()) {
        rootRecord(root).prefill = {id:attempt.id, size:state.size, signature:state.signature, edited:false};
        persistPrefill(root);
      }
      safeTrack('prefill_success',payload);
    } else { payload.error_code = state.selected === state.size ? 'unchanged_selection' : 'incomplete_fill'; safeTrack('prefill_error',payload); }
    checkComplete(root);
  }
  function checkComplete(root) {
    var state = readState(root), record = rootRecord(root);
    var complete = state.size > 0 && state.selected === state.size;
    if (complete && !record.complete) safeTrack('bundle_completed',Object.assign(context(root), {pack_count:state.size,purchase_type:state.purchase_type,prefill_used:Boolean(record.prefill)}));
    record.complete = complete;
  }
  function beginPurchase(payload, button, options) {
    if (options && options.internal) return null;
    var root = selectionRoot(button) || document.querySelector('.product-bundle, .component-product-info-alt');
    var food = (payload.items || []).filter(function(item) { var p=item.properties||{}; return !p._linkedToMainItem && p._is_gift_of === undefined && !p._free_gift_for_bundle; });
    var count = food.reduce(function(sum,item) { return sum + (Number(item.quantity)||0); },0);
    var record = root && rootRecord(root);
    var prefill = record && record.prefill;
    var upsell = Boolean(button && button.closest('.recomended__add-to-cart'));
    var operation = {id:id(),root:root,prefill:prefill,finished:false,upsell:upsell,context:Object.assign(context(root), {pack_count:count,purchase_type:food.some(function(item) { return Boolean(item.selling_plan); })?'subscription':'oneoff',destination:options && options.checkout?'checkout':'cart',prefill_used:Boolean(prefill),prefill_edited:Boolean(prefill && prefill.edited)})};
    if (upsell) operation.context.source='cart_drawer';
    if (!upsell) safeTrack('purchase_intent',operation.context);
    return operation;
  }
  function attributePurchase(payload, operation) {
    if (!operation || operation.upsell || !preview && !analyticsAllowed()) return payload;
    var prefill = operation.prefill;
    return Object.assign({},payload,{items:(payload.items||[]).map(function(item) {
      var props=Object.assign({},item.properties||{});
      if (props._linkedToMainItem || props._is_gift_of !== undefined || props._free_gift_for_bundle) return item;
      props._eleatTrackingVersion=VERSION;
      props._eleatJourneySource=operation.context.source;
      if (prefill) {
        props._eleatPrefillUsed='true';props._eleatPrefillId=prefill.id;props._eleatPrefillSize=String(prefill.size);props._eleatPrefillSource=operation.context.source;props._eleatPrefillEdited=String(prefill.edited);
      }
      return Object.assign({},item,{properties:props});
    })});
  }
  function finishPurchase(operation, outcome, details) {
    if (!operation || operation.finished) return false;
    operation.finished=true;
    var data=Object.assign({},operation.context,details||{}, {attempt_id:operation.id});
    if (operation.upsell) { if(outcome==='success') safeTrack('cart_upsell_success',data); }
    else safeTrack(outcome==='success'?'purchase_success':'purchase_error',data);
    if(outcome==='success' && !operation.upsell && operation.root) {
      var record=roots.get(operation.root); if(record) record.prefill=null;
      try {window.sessionStorage.removeItem('eleat:prefill:' + location.pathname);} catch(_) {}
    }
    return true;
  }
  function afterSelection(root, name, before, extra) {
    window.setTimeout(function () {
      var state=readState(root), record=rootRecord(root);
      var changed=state.signature!==before.signature || state.size!==before.size || state.purchase_type!==before.purchase_type || state.cadence_weeks!==before.cadence_weeks;
      if(changed) {
        safeTrack(name,Object.assign(context(root), {pack_count:state.size,selected_count:state.selected,purchase_type:state.purchase_type,cadence_weeks:state.cadence_weeks},extra||{}));
        if(record.prefill && !record.prefill.edited && (state.signature!==record.prefill.signature || state.size!==record.prefill.size)) {
          record.prefill.edited=true; safeTrack('prefill_edited',Object.assign(context(root), {prefill_id:record.prefill.id,pack_count:state.size}));
        }
      }
      checkComplete(root);
      persistPrefill(root);
      root.querySelectorAll('[data-bab-prefill], [data-autofill-button], .build-a-bundle__autofill-trigger').forEach(prefillViewed);
    },0);
  }
  document.addEventListener('click',function(event) {
    if (!event.isTrusted || !event.target || !event.target.closest) return;
    var node=event.target.closest('button, a, summary, [role="button"], [role="radio"], .build-a-bundle__size-button, .product-template__plan-option, [data-bab-plan-card], .bundle-card__quantity-add, .bundle-card__quantity-plus, .bundle-card__quantity-minus');
    if(!node || !enabled(node) || !visible(node,false)) return;
    var root=selectionRoot(node), before=root && readState(root);
    if(root) rootRecord(root);
    if(root && node.matches('[data-bab-prefill], [data-autofill-button], .build-a-bundle__autofill-trigger')) {
      var attempt={id:id(),before:before};
      try {
        var quick=node.closest('.build-a-bundle__quick-bundle');
        var preset=quick && quick.querySelector('[data-preset-products="'+before.size+'"]');
        if(preset) {
          var expected={}; JSON.parse(preset.textContent).forEach(function(product){product=String(product);expected[product]=(expected[product]||0)+1;});
          attempt.expectedSignature=JSON.stringify(Object.keys(expected).sort().map(function(key){return [key,expected[key]];}));
        }
      } catch(_) {attempt.expectedSignature='invalid_configuration';}
      safeTrack('prefill_intent',Object.assign(context(root), {prefill_id:attempt.id,pack_count:before.size,previous_count:before.selected,purchase_type:before.purchase_type}));
      window.setTimeout(function(){finishPrefill(root,attempt);},0);return;
    }
    if(root) {
      if(node.matches('.build-a-bundle__size-button')) { afterSelection(root,'pack_selected',before); return; }
      if(node.matches('.product-template__plan-option, [data-bab-plan-card], .build-a-bundle__type-button--subscribe, .build-a-bundle__type-button--oneoff')) { afterSelection(root,'plan_selected',before); return; }
      if(node.matches('.build-a-bundle__type-subscription')) { afterSelection(root,'frequency_selected',before); return; }
      if(node.matches('[data-flavour-plus], [data-flavour-minus], .bundle-card__quantity-add, .bundle-card__quantity-plus, .bundle-card__quantity-minus, .build-a-bundle__fixed-product-btn, [data-bab-box-minus], [data-bab-box-plus], [data-prefill-action], [data-bab-desktop-action]')) { afterSelection(root,'flavour_changed',before); return; }
      if(node.matches('.product-template__plan-cta')) { safeTrack('plan_continue',Object.assign(context(root),{pack_count:before.size,purchase_type:before.purchase_type})); return; }
      if(node.matches('.product-template__back-to-plan')) { safeTrack('back_to_plan',context(root)); return; }
      if(node.matches('.bab-range-pill')) { safeTrack('range_selected',Object.assign(context(root),{range:node.dataset.rangeTarget})); return; }
    }
    if(node.closest('.cart-aside')) {
      if(node.matches('[name="checkout"], a[href="/checkout"]')) safeTrack('checkout_intent',{source:'cart_drawer'});
      else if(node.matches('.recomended__add-to-cart')) safeTrack('cart_upsell_intent',{source:'cart_drawer'});
      else if(node.matches('.cart-aside__bundle-item-delete, .cart-aside__item-delete, .cart-aside__item-remove')) safeTrack('cart_remove_intent',{source:'cart_drawer'});
      else if(node.matches('.quantity__plus, .quantity__minus')) safeTrack('cart_quantity_intent',{source:'cart_drawer'});
      else if(node.matches('[data-eleat-edit-bundle], .cart-aside__bundle-item-edit')) safeTrack('cart_edit_intent',{source:'cart_drawer'});
    }
    if(node.matches('[data-bab-nutrition-button], [data-nutrition-open], [data-nutrition-dialog-open], .product-template__variety-pack-ingredients, .product-template__model-trigger--nutrition, .product-template__model-button--nutritionals, .variety-pack-nutrition-trigger')) safeTrack('nutrition_opened',context(root));
    if(node.matches('[data-eleat-guarantee-open], [data-guarantee-open]')) safeTrack('guarantee_opened',context(root));
    if(node.matches('[data-eleat-review-tabs] [role="tab"], a[href="#trustpilot-review"], a[href="#eleat-tabbed-reviews"], [data-eleat-review-next], [data-eleat-review-prev]')) safeTrack('reviews_opened',context(root));
    if(node.matches('.product-faqs__faq-question, .faqs-lists__faq-question, .product-template__accordion-button, .build-a-bundle__accordion-question, summary')) {
      var wasOpen=faqOpen(node);
      window.setTimeout(function(){if(!wasOpen && faqOpen(node)) safeTrack('faq_opened',context(root));},0);
    }
    if(node.closest('.site-header') && node.matches('a[href^="/products/"], a[href^="/pages/"], a[href^="/collections/"]')) safeTrack('shop_navigation',{destination:node.getAttribute('href').split('?')[0]});
  },true);
  document.addEventListener('change',function(event) {
    if(!event.isTrusted || !event.target || !event.target.matches) return;
    var node=event.target,root=selectionRoot(node);
    if(root && node.matches('.bab-frequency-select')) window.setTimeout(function(){var state=readState(root);safeTrack('frequency_selected',Object.assign(context(root),{pack_count:state.size,purchase_type:state.purchase_type,cadence_weeks:parseInt(node.value,10)||0}));},0);
    if(node.closest('.cart-aside') && node.matches('.type-subscriptions__plans')) safeTrack('cart_frequency_selected',{source:'cart_drawer',measurement:'intent'});
    if(node.closest('.cart-aside') && node.matches('.variant-select')) safeTrack('cart_variant_intent',{source:'cart_drawer'});
  },true);
  function discover() {
    discoverTimer=0;
    document.querySelectorAll('.product-bundle, .component-product-info-alt').forEach(function(root){ if(!root.classList.contains('eleat-bundle-live-gallery')) once(root,'journey','journey_viewed',context(root)); });
    var cart=document.querySelector('.cart-aside--active');
    if(cart) once(cart,'cart-view','cart_viewed',{source:'cart_drawer'});
    document.querySelectorAll('[data-bab-prefill], [data-autofill-button], .build-a-bundle__autofill-trigger, [data-js-subscription-upgrade-toggle]').forEach(function(node) {
      if(!observed.has(node)) { observed.add(node); if(viewObserver) viewObserver.observe(node); }
      inspectViewed(node);
    });
  }
  function inspectViewed(node) {
    if(node.matches('[data-js-subscription-upgrade-toggle]')) {
      if(!visible(node,true) || !enabled(node) || !preview && !analyticsAllowed()) return;
      var bundle=node.closest('.cart-aside__bundle-item');
      var bundleId=String(bundle && bundle.dataset.bundleUuid || '');
      var data={source:'cart_drawer',pack_count:Number(node.dataset.upgradePackCount)||0,cadence_weeks:Number(node.dataset.upgradeCadenceWeeks)||0};
      if(!bundleId) { once(node,'upgrade-view','cart_subscription_upgrade_viewed',data); return; }
      var key='eleat:upgrade-viewed:' + (preview?'draft:':'main:') + VERSION + ':' + bundleId;
      if(seenUpgradeBundles.has(key)) return;
      try {
        if(window.sessionStorage.getItem(key)==='1') {seenUpgradeBundles.add(key);return;}
      } catch(_) {}
      data.bundle_id=bundleId;
      if(safeTrack('cart_subscription_upgrade_viewed',data)) {
        seenUpgradeBundles.add(key);
        try {window.sessionStorage.setItem(key,'1');} catch(_) {}
      }
    } else prefillViewed(node);
  }
  function scheduleDiscover() { if(!discoverTimer) discoverTimer=window.setTimeout(discover,100); }
  function init() {
    if(window.IntersectionObserver) viewObserver=new IntersectionObserver(function(entries){entries.forEach(function(entry){if(entry.isIntersecting) inspectViewed(entry.target);});},{threshold:0.25});
    discover();
    if(window.MutationObserver) new MutationObserver(scheduleDiscover).observe(document.body,{subtree:true,childList:true,attributes:true,attributeFilter:['class','hidden','style']});
  }
  function initPrivacy() {
    if(window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.analyticsProcessingAllowed === 'function') { consentReady=true; scheduleDiscover(); return; }
    if(window.Shopify && typeof window.Shopify.loadFeatures === 'function') window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],function(error){consentReady=!error && Boolean(window.Shopify.customerPrivacy);scheduleDiscover();});
  }
  document.addEventListener('visitorConsentCollected',function(){
    consentReady=Boolean(window.Shopify && window.Shopify.customerPrivacy);
    if(!preview && !analyticsAllowed()) {
      pending=[];roots=new WeakMap();seenUpgradeBundles=new Set();
      try {
        for(var index=window.sessionStorage.length-1;index>=0;index--) {var key=window.sessionStorage.key(index);if(key && (key.startsWith('eleat:prefill:') || key.startsWith('eleat:upgrade-viewed:'))) window.sessionStorage.removeItem(key);}
        window.sessionStorage.removeItem('eleat:prefill:' + location.pathname);
      } catch(_) {}
    }
    scheduleDiscover();
  });
  window.eleatTracking={version:VERSION,preview:preview,events:events,track:track,beginPurchase:beginPurchase,attributePurchase:attributePurchase,finishPurchase:finishPurchase,readState:readState};
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){initPrivacy();init();},{once:true}); else {initPrivacy();init();}
})();
